import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './style/app.css';
import reportWebVitals from './reportWebVitals';
import AppRouter from './routers/AppRouter';
import { ThemeProvider } from './context/ThemeContext';
import { AppContextProvider } from './context/AppContext';
import PageLoader from './components/PageLoader';
import ErrorBoundary from './components/ErrorBoundary';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<PageLoader />}>
        <ThemeProvider>
          <AppContextProvider>
            <AppRouter />
          </AppContextProvider>
        </ThemeProvider>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);

// Measure performance
reportWebVitals();
